// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/components/home/HomeFooter.tsx
// 🔧 PURPOSE: La chiusura della Home, come il piede delle email: il filo
//             d'oro sottile e "NONNA VITTORIA APARTMENTS · MOLA DI BARI".
//             Il marchio resta scritto così in tutte le lingue.
// ============================================

import React from 'react';
import { cn } from '../../lib/utils';
import { GoldRule } from './ui';
import InstallAppCard from '../install/InstallAppCard';

const HomeFooter: React.FC<{ className?: string }> = ({ className }) => (
  <>
  {/* Finché l'app non è installata: "Installa l'app" (apre il foglio). */}
  <InstallAppCard />
  <footer className={cn('flex flex-col items-center gap-2 px-4 pb-2 pt-[26px]', className)}>
    <GoldRule thin />
    {/* 5 tocchi veloci qui (o sullo stemma): la prova della barra di stato, solo per il proprietario. */}
    <p data-status-probe="" className="m-0 text-center text-[10px] font-bold uppercase leading-relaxed tracking-[0.2em] text-nva-muted dark:text-stone-400">
      Nonna Vittoria Apartments · Mola di Bari
    </p>
  </footer>
  </>
);

export default HomeFooter;
